import { Add, Close } from '@mui/icons-material';
import '../Profile.css'
import { Box, OutlinedInput } from "@mui/material"
import CircularIndeterminate from "components/blocks/progressBar/progressBar";
import ButtonLarge1 from 'components/elements/ButtonLarge1';
import ButtonMedium1 from 'components/elements/ButtonMedium1';
import ButtonMedium4 from 'components/elements/ButtonMedium4';
import ConfirmDialog from 'components/elements/ConfirmDialog';
import ContentNormal from "components/elements/ContentNormal";
import Headline5 from "components/elements/Headline5";
import { AppContext } from "contexts/AppContext";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { callAPI } from "utils/API";
import { translate } from 'utils/Translate';
import IconButtonSmall from 'components/elements/IconButtonSmall';
import ContentSmall from 'components/elements/ContentSmall';
import Headline6 from 'components/elements/Headline6';

const CustomerCardsPage = () => {
    const { styleGuide } = useContext(AppContext)
    const [loading, setLoading] = useState(true)
    const [customerCards, setCustomerCards] = useState([])

    const fetchCustomerCards = async () => {
        let userCustomerCards = await callAPI(`/user/customerCards`, 'GET')
        if (!userCustomerCards || !userCustomerCards.length){
            setCustomerCards([])
            setLoading(false)
        }
        
        userCustomerCards = userCustomerCards.map(customerCard => ({...customerCard, timeInsert: moment(customerCard.timeInsert).format("DD.MM.YYYY")}))

        setCustomerCards(userCustomerCards)
        setLoading(false)
    }

    const onRegisterCard = (customerCard) => {
        setCustomerCards([...customerCards, customerCard])
    }

    const onRemoveCard = (CustomerCardID) => {
        setCustomerCards(customerCards.filter(c => c.CustomerCardID !== CustomerCardID))
    }

    useEffect(() => {
        fetchCustomerCards()
    }, [])

    return (
        <Box flex={1} display={'flex'} flexDirection={'column'} gap={6} marginBottom={10}>
            <CustomerCardRegisterForm onRegisterCard={onRegisterCard} />

            <Box flex={1} display={'flex'} flexDirection={'column'} gap={2}>
                <Headline5
                    translationKey="_CUSTOMER_CARDS_LIST_HEADLINE_"
                    fallbackText="Dine registrerede kundekort"
                />
                {loading
                    ?
                    <Box display={'flex'} flex={1} justifyContent={'center'} marginTop={2}>
                        <CircularIndeterminate />
                    </Box>
                    : !customerCards.length
                        ?
                        <Box
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "1rem",
                                border: `1px solid ${styleGuide.color4}`,
                                borderRadius: "14px",
                                padding: 40,
                            }}
                        >
                            <Headline5
                                translationKey="_PROFILE_PAGE_NO_CUSTOMER_CARDS_CAPTION_"
                                fallbackText="Du har ingen kundekort endnu"
                                style={{textAlign: 'center'}}
                            />
                            <ContentNormal
                                translationKey="_PROFILE_PAGE_NO_CUSTOMER_CARDS_TEXT_"
                                fallbackText="Registrer dit første kundekort for at modtage 50 point."
                                style={{textAlign: 'center'}}
                            />
                        </Box>
                        :
                        <Box display={'flex'} flexWrap={'wrap'} gap={4}>
                            {customerCards.map((customerCard, idx) => (
                                <CustomerCard customerCard={customerCard} onRemoveCard={onRemoveCard} index={idx} />
                            ))}
                        </Box>
                }
            </Box>
        </Box>
    );
}

const CustomerCard = (props) => {
    const { onRemoveCard, customerCard, index } = props
    const { styleGuide } = useContext(AppContext)
    const [showRemoveConfirm, setShowRemoveConfirm] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const removeCustomerCard = async () => {
        setIsLoading(true)
        const removeCardResponse = await callAPI(`/user/removeCustomerCard`, 'POST', { body: { CustomerCardID: customerCard.CustomerCardID } })
        if (removeCardResponse && removeCardResponse.removed){
            onRemoveCard(customerCard.CustomerCardID)
        }

        setIsLoading(false)
        setShowRemoveConfirm(false)
    }

    return (
        <>
            <Box key={customerCard.CustomerCardID} border={`1px solid ${styleGuide.color4}`} borderRadius={'14px'} width={{xs: '100%', sm: 320}} padding={2}>
                <Box display={'flex'} flexDirection={'column'} gap={1}>
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Headline5>
                            {`${translate("_CUSTOMER_CARD_HEADLINE_", "Kundekort")} ${index+1}`}
                        </Headline5>
                        <IconButtonSmall
                            loading={isLoading}
                            title={translate('_CUSTOMER_CARD_REMOVE_LABEL_', 'Fjern')}
                            icon={<Close fontSize='small' style={{color: 'black'}} />}
                            onClick={setShowRemoveConfirm}
                        />
                    </Box>

                    <Box display={'flex'} gap={1}>
                        <ContentNormal
                            translationKey="_CUSTOMER_CARD_NUMBER_"
                            fallbackText="Kortnummer:"
                        />

                        <Headline6>
                            {customerCard.cardUID}
                        </Headline6>
                    </Box>

                    <Box display={'flex'} gap={1} marginTop={2}>
                        <ContentSmall
                            translationKey="_CUSTOMER_CARD_REGISTERED_LABEL_"
                            fallbackText="Registreret d."
                            style={{color: styleGuide.color5}}
                        />
                        <ContentSmall style={{color: styleGuide.color5}}>
                            {customerCard.timeInsert}
                        </ContentSmall>
                    </Box>
                </Box>
            </Box>

            <ConfirmDialog
                show={showRemoveConfirm}
                headline={translate("_CUSTOMER_CARD_REMOVE_DIALOG_HEADLINE_", "Fjern kundekort")}
                onConfirm={removeCustomerCard}
                onHide={() => setShowRemoveConfirm(false)}
            >
                <ContentNormal
                    translationKey="_CUSTOMER_CARD_REMOVE_DIALOG_TEXT_"
                    fallbackText="Er du sikker på at du vil fjerne dette kundekort?"
                />
            </ConfirmDialog>
        </>
    )
}

const CustomerCardRegisterForm = (props) => {
    const { onRegisterCard } = props
    const { styleGuide, accessibleShops, userData, setUserData } = useContext(AppContext)
    const navigate = useNavigate()
    const [cardUID, setCardUID] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [showRewardModal, setShowRewardModal] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [registerError, setRegisterError] = useState(false)
    const ShopID = accessibleShops?.length > 0 ? accessibleShops[0].ShopID : null
    
    const createCustomerCard = async () => {
        setIsLoading(true)
        const createdCustomerCardResponse = await callAPI('/user/customerCards', 'POST', { body: { cardUID: cardUID } })
        
        if (!createdCustomerCardResponse || createdCustomerCardResponse.error || !createdCustomerCardResponse.customerCard){
            if(createdCustomerCardResponse.error) {
                setRegisterError(createdCustomerCardResponse.error)

            }
            setShowErrorModal(true)
            setIsLoading(false)
            return
        }

        onRegisterCard({...createdCustomerCardResponse.customerCard, timeInsert: moment(createdCustomerCardResponse.customerCard.timeInsert).format("DD.MM.YYYY")})
        setCardUID('')
        
        if(createdCustomerCardResponse.rewardedPoints){
            setShowRewardModal(true)
            setUserData({
                ...userData,
                walletAmountPoints: userData.walletAmountPoints + createdCustomerCardResponse.rewardedPoints,
            })
        }

        setIsLoading(false)
    }

    const hideRewardModal = () => {
        setShowRewardModal(false)
    }

    const hideErrorModal = () => {
        setShowErrorModal(false)
    }

    return (
        <Box display={'flex'} flexDirection='column' gap={2}>
            <Headline5
                translationKey="_CUSTOMER_CARD_ADD_HEADLINE_"
                fallbackText="Registrer nyt kundekort"
            />
            <Box display={'flex'} gap={2} flexWrap={'wrap'}>
                <OutlinedInput
                    style={{
                        borderRadius: 14,
                        border: `1px solid ${styleGuide.color4}`,
                        height: 45,
                        width: 260,
                    }}
                    value={cardUID}
                    onChange={(v) => setCardUID(v.target.value)}
                    placeholder='Kundekortnummer'
                />
                <ButtonLarge1
                    loading={isLoading}
                    showIcon={false}
                    translationKey="_CUSTOMER_CARD_ADD_BUTTON_"
                    fallbackText="Registrer kundekort"
                    onClick={createCustomerCard}
                    style={{minWidth: 176}}
                />
            </Box>

            <Modal
                show={showErrorModal}
                onHide={hideErrorModal}
                style={{ margin: "auto" }}
                centered
            >
                <Modal.Header
                    className="border-0"
                    closeButton
                    style={{ fontSize: 9 }}
                >
                    <Headline5
                        translationKey="_CUSTOMER_CARD_ADD_ERROR_HEADLINE_"
                        fallbackText="Kunne ikke registrere kundekort"
                    />                        
                </Modal.Header>
                <Modal.Body className="pt-0">
                    {registerError === 'CUSTOMER_CARD_ALREADY_REGISTERED'
                        ?
                            <ContentNormal
                                translationKey="CUSTOMER_CARD_ALREADY_REGISTERED"
                                fallbackText="Kundekortet kunne ikke registreres da det allerede er registreret."
                            />
                        : registerError === 'CUSTOMER_CARD_UID_INVALID'
                            ?
                                <ContentNormal
                                    translationKey="CUSTOMER_CARD_UID_INVALID"
                                    fallbackText="Kundekortet kunne ikke registreres da kortnummeret ikke er gyldigt."
                                />
                            :
                                <ContentNormal
                                    translationKey="_CUSTOMER_CARD_ADD_ERROR_MESSAGE_"
                                    fallbackText="Der gik noget galt. Prøv venligst igen."
                                />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Box
                        display={'flex'}
                        justifyContent={'flex-end'}
                        gap={2}
                    >
                        <ButtonMedium4
                            showIcon={false}
                            translationKey="_CLOSE_"
                            fallbackText="Luk"
                            onClick={hideErrorModal}
                        />
                    </Box>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showRewardModal}
                onHide={hideRewardModal}
                style={{ margin: "auto" }}
                centered
            >
                <Modal.Header
                    className="border-0"
                    closeButton
                    style={{ fontSize: 9 }}
                >
                    <Headline5
                        translationKey="_CUSTOMER_CARD_REWARD_HEADLINE_"
                        fallbackText="Tillykke!"
                    />                        
                </Modal.Header>
                <Modal.Body className="pt-0">
                    <ContentNormal
                        translationKey="_CUSTOMER_CARD_REWARD_TEXT_"
                        fallbackText="Du har registreret dit første kundekort og har derfor modtaget 50 point som du kan bruge i shoppen."
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Box
                        display={'flex'}
                        justifyContent={'flex-end'}
                        gap={2}
                    >
                        <ButtonMedium1
                            showIcon={false}
                            translationKey="_CUSTOMER_CARD_REWARD_SHOP_BUTTON_TEXT_"
                            fallbackText="Gå til shoppen"
                            onClick={() => navigate(`/shop/${ShopID}`)}
                        />
                        <ButtonMedium4
                            showIcon={false}
                            translationKey="_CLOSE_"
                            fallbackText="Luk"
                            onClick={hideRewardModal}
                        />
                    </Box>
                </Modal.Footer>
            </Modal>
        </Box>
    )
}

export default CustomerCardsPage